import NavigationBar from "../../components/NavigationBar";
import CustomInput from "../../components/CustomInput";
import styles from "../styles/FindActivitiesHeader.module.scss";
import PeopleIcon from "../../../public/assets/people-icon.svg";

export default function FindActivitiesHeader() {
  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <NavigationBar></NavigationBar>
        <div className={styles["find-activity"]}>
          <h2>Find activities you enjoy</h2>
          <CustomInput></CustomInput>
        </div>
      </div>
      <PeopleIcon className={styles.icon}></PeopleIcon>
    </div>
  );
}
